import { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  borderColor?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

export function StatCard({ title, value, icon, borderColor, trend }: StatCardProps) {
  return (
    <div
      className="bg-white p-3 sm:p-4 md:p-5 lg:p-6 rounded-lg shadow-sm border border-gray-200 transition-all duration-200 hover:shadow-md"
      style={borderColor ? { borderLeftWidth: '4px', borderLeftStyle: 'solid', borderLeftColor: borderColor } : undefined}
    >
      <div className="flex justify-between items-start gap-2">
        <div className="space-y-1 sm:space-y-1.5 md:space-y-2 flex-1 min-w-0">
          <p className="text-[10px] sm:text-xs md:text-sm font-medium text-gray-600 truncate">{title}</p>
          <p className="text-base md:text-lg lg:text-2xl font-bold text-gray-900 break-words">{value}</p>
          {trend && (
            <p className={`text-[10px] sm:text-xs md:text-sm flex items-center ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`}>
              {trend.isPositive ? '\u2191' : '\u2193'} {trend.value}%
            </p>
          )}
        </div>
        <div className="text-[#00665C] flex-shrink-0">{icon}</div>
      </div>
    </div>
  );
}
